import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';
import { lightPageTheme } from './custom-page-theme';
import { sharedThemeOptions } from './shared';

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      background: { paper: '#FFFFFF' },
      navigation: {
        ...palettes.light.navigation,
        background: '#f8f8f8', // Note: should be var(--bui-bg-app) but causes issues with AsyncApi card for API entities
        indicator: 'transparent',
        color: '#4A4542',
        selectedColor: '#1A1A1A',
        navItem: { hoverBackground: '#DEDEDE' },
        submenu: { background: '#DEDAD6' },
      },
      link: '#1A5FA0',
      linkHover: '#144880',
      textContrast: '#000000',
      textSubtle: '#6B6560',
      textVerySubtle: '#B0AAA5',
    },
  }),
  pageTheme: lightPageTheme,
  components: {
    ...sharedThemeOptions,
    MuiPaper: {
      styleOverrides: {
        root: {
          border: '1px solid var(--bui-border-1)',
        },
        elevation1: {
          boxShadow: 'none',
        },
        elevation2: {
          boxShadow: 'none',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: { '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } },
      },
    },
  },
});
